export default {
      id: "close-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#close",
      toString: function () {
        return this.url;
      }
    }